import { render, staticRenderFns } from "./ListViewWithDataHandler.vue?vue&type=template&id=255dae69&scoped=true&"
import script from "./ListViewWithDataHandler.vue?vue&type=script&lang=js&"
export * from "./ListViewWithDataHandler.vue?vue&type=script&lang=js&"
import style0 from "./ListViewWithDataHandler.vue?vue&type=style&index=0&id=255dae69&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "255dae69",
  null
  
)

export default component.exports